<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";


import {


} from 'devextreme-vue/data-grid';
import Swal from "sweetalert2";
import api from "@/axios";
import Loader from "@/router/views_mobagile/components/loader.vue";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Loader, Layout, PageHeader



  },
  data() {

    return {
      title: "Tabelas de Frete Padrão",
      items: [
        {
          text: "Tabelas Base",
          href: "/cotacaofretesbaseelk/list",
        },
        {
          text: "Tabelas de Frete Padrão",
          active: true
        }
      ],
      updating: true,
      tabelasData: null,
    };
  },
  created() {

  },
  mounted() {

    this.carregarDados()

  },



  methods: {

    carregarDados() {
      console.log('carregarDados_imp_padrao')
      this.updating = true
      api.get(`${getBaseUrl()}api/frtbselkdef`).then((res) => {
        console.log('then axios cotaFreteBase')
        console.log(res.data)
        let tabsFinal = []
        res.data[0].forEach((tabela) => {
          console.log('tabela')
          console.log(tabela.transpcnpj)
          try {
            tabela.img1 = require(`@/assets/images/logotransp/${tabela.transpcnpj}.png`)
          } catch (e) {
            tabela.img1 = require('@/assets/images/logotransp/1234567891.png')
          }
          tabsFinal.push(tabela)
        })
        this.tabelasData = tabsFinal
        this.updating = false
      })
    },


    copiarTabela(tabela){
      console.log('copiarTabela')
      console.log(tabela)
      if (tabela) {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Importar Tabela " + tabela.descricao,
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.updating = true
            api.post(`${getBaseUrl()}api/frtbselkcopbas`, {
              idTabela: tabela._idtabela
            }).then((res) => {
              console.log('res post ocorfinal')
              console.log(res)
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Base importada com sucesso.",
                showConfirmButton: false,
                timer: 1500
              })
              this.updating = false
            })
          }
        })
      }
    }
  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 200px;">
    </Loader>



    <div class="row" v-if="!updating">



      <div class="col-xl-3" v-for="tab in tabelasData" :key="tab._id">
        <a href="#" @click="copiarTabela(tab)">
          <div class="card bg-soft bg-primary">
            <div>
              <div class="row">
                <div class="col-7">
                  <div class="text-primary p-3">
                    <h5 class="text-primary">{{ tab.descricao }}</h5>
                    <p>01/10/2025</p>

                    <ul class="ps-3 mb-0">
                      <li class="py-1">+700 TRT's</li>
                      <li class="py-1">+700 TDA's</li>
                      <li class="py-1">.150 TDe's</li>
                    </ul>
                  </div>
                </div>
                <div class="col-5 align-self-end mb-3" style="max-width: 150px;">
                  <img
                      :src="tab.img1"
                      alt
                      class="img-fluid fade-edges"
                  />
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>


    </div>



  </Layout>
</template>

<style scoped>
/* Suaviza as bordas da imagem para misturar com o fundo do card */
.fade-edges {
  display: block;
  /* A máscara deixa opaco no centro e vai ficando transparente nas bordas */
  -webkit-mask-image: radial-gradient(120% 140% at 50% 50%, #000 60%, transparent 100%);
  mask-image: radial-gradient(120% 140% at 50% 50%, #000 60%, transparent 100%);
  /* Opcional: bordas levemente arredondadas antes da máscara */
  border-radius: 8px;
}

/* Caso queira um fade mais sutil (aumente a área opaca) */
/*
.fade-edges {
  -webkit-mask-image: radial-gradient(130% 150% at 50% 50%, #000 70%, transparent 100%);
  mask-image: radial-gradient(130% 150% at 50% 50%, #000 70%, transparent 100%);
}
*/
</style>
